module.exports = __webpack_public_path__ + "media/img/pages/profile/zhaw ger 4-2b91d5e7fcdbba69c364ce53e0ef3fe0.jpg";